/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PolicyStatusEnums {
    NEW_SUBMISSION = 1,
    RENEWAL = 2,
    INDICATION = 3,
    ISSUED = 4,
    WAITING_FOR_INFO = 5,
    ENDORSED = 6,
    AUDITED = 7,
    EXPIRED = 8,
    LOST = 9,
    DECLINED = 10,
    CANCELLED = 11,
    DELETED = 12,
    QUOTED = 13,
    READY_TO_BIND = 14,
}
